import { createExternalStore } from '@iheartjane/utils';
import { useSyncExternalStore } from 'react';

const { subscribe } = createExternalStore();

export const useIsHydrated = () =>
  useSyncExternalStore(
    subscribe,
    () => true,
    () => false
  );
